import { getDataLayer } from './google-consent-mode.js';
import { findScript, injectScript, tagUrl, warn } from '../utils.js';

/** Where gtm.js comes from unless `google.gtm.src` or a container's `src` points at a first-party endpoint. */
export const GTM_SRC = 'https://www.googletagmanager.com/gtm.js';

/**
 * Loads GTM containers in config order. Containers are independent: one that is already on the
 * page, misconfigured or failing to load never blocks the others. They all read the same
 * centrally managed Consent Mode state that was queued in their dataLayer before this runs.
 */
export function loadGtmContainers(win, containers, { nonce } = {}) {
  for (const { id, dataLayer, src = GTM_SRC } of containers) {
    try {
      const loaded = (win.google_tag_manager && win.google_tag_manager[id]) || findScript(win.document, { id, src, pathSuffix: '/gtm.js' });
      if (loaded) continue;

      const layer = getDataLayer(win, dataLayer);
      if (!layer) throw new Error(`window.${dataLayer} is not a dataLayer`);
      layer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

      injectScript(win.document, tagUrl(src, id, dataLayer), {
        nonce,
        onError: () => warn(`GTM container ${id} failed to load`),
      });
    } catch (error) {
      warn(`GTM container ${id} skipped:`, error);
    }
  }
}
